import { useState, useEffect } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import axiosClient from "../../api/axios";

export default function Value({ hasBg }) {
  
  const [ourValues, setOurValues] = useState(null);
  const [loadingOurValues, setLoadingOurValues] = useState(true);

  useEffect(() => {
    const fetchOurValues = async () => {
      try {
        const response = await axiosClient.get(`/api/our-values/`);
        setOurValues(response.data.data);
      } catch (error) {
        console.error("Failed to fetch study:", error);
      } finally {
        setLoadingOurValues(false);
      }
    };

    fetchOurValues();
  }, []);

  if (loadingOurValues) {
  return (
      <section
        className={`package-section ${
          hasBg ? "gray-light-bg" : "background-shape-right"
        } ptb-100`}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <ClipLoader color="#0d6efd" size={80} />
      </section>
    );
  }


  return (
    <>
      <div className="overflow-hidden">
        <section
          id="pricing"
          className={`package-section ${
            hasBg ? "gray-light-bg" : "background-shape-right"
          } ptb-100`}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="section-heading text-center mb-5">
                  <h3>{ourValues?.title}</h3>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              {ourValues?.sections?.map((data) => (
                <div key={data?.id} className="col-lg-4 col-md">
                  <div
                    className={`card text-center single-pricing-pack p-5 h-100 ${
                      data?.main ? "popular-price" : ""
                    }`}
                  >
                    <h5 className="mb-2">{data?.title}</h5>
                    <div className="pricing-img mt-3 mb-4">
                      <img
                        src={data?.icon_url}
                        alt="pricing img"
                        className="img-fluid"
                      />
                    </div>

                    <div className="card-body p-0">
                      <p>{data?.description}</p>
                      {/* <div className="py-4 border-0 pricing-header">
                      <div className="h1 text-center mb-0 color-secondary">
                        $<span className="price font-weight-bolder">29</span>
                      </div>
                    </div> */}
                      {/* <a href="#/" className="btn outline-btn" target="_blank">
                      Purchase now
                    </a> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
